import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Obsequios from "./components/Obsequios";
import ObsequiosEjecutivo from "./components/ObsequiosEjecutivo";
import Layout from "./components/Layout";
import PerfilEmpleado from "./components/PerfilEmpleado";
import AdminHub from "./components/AdminHub";
import Beneficios360 from "./components/Beneficios360";
import Inventario from "./components/Inventario";
import Despachos from "./components/Despachos";
import AfiliacionPublica from "./components/AfiliacionPublica";
import Afiliaciones from "./components/Afiliaciones";
import Campaigns from "./components/Campaigns/Campaigns";
import CampaignDetail from "./components/Campaigns/CampaignDetail";
import Reportes from "./components/Reportes";
import Informes from "./components/Informes";
import BancoBonos from "./components/BancoBonos";
import OrdenKompralo from "./components/OrdenKompralo";
import Creditos from "./components/Creditos";
import Solicitudes from "./components/Solicitudes";
import Payroll from "./components/Payroll/Payroll";
import PayrollClientDetail from "./components/Payroll/PayrollClientDetail";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showSessionExpired, setShowSessionExpired] = useState(false);

  useEffect(() => {
    const lsUser = localStorage.getItem("user");
    const lsToken = localStorage.getItem("token");

    if (lsUser && lsToken) {
      setUser(JSON.parse(lsUser));
      setIsAuthenticated(true);
      setLoading(false);
      return;
    }

    const ssUser = sessionStorage.getItem("user");
    const ssToken = sessionStorage.getItem("token");

    if (ssUser && ssToken) {
      setUser(JSON.parse(ssUser));
      setIsAuthenticated(true);
    }

    setLoading(false);
  }, []);

  useEffect(() => {

    const handler = () => {

      console.log(
        "🚨 EVENTO SESSION-EXPIRED RECIBIDO"
      );

      handleLogout();

      setShowSessionExpired(
        true
      );

    };

    window.addEventListener(
      "session-expired",
      handler
    );

    return () => {

      window.removeEventListener(
        "session-expired",
        handler
      );

    };

  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    setIsAuthenticated(false);
    setUser(null);
  };

  const PrivateRoute = ({
    children
  }) => {

    if (loading) {
      return null;
    }

    if (
      showSessionExpired
    ) {

      return null;

    }

    return isAuthenticated
      ? children
      : <Navigate to="/login" replace />;

  };

  const AdminRoute = ({ children }) => {
    return isAuthenticated && user?.rol.toLowerCase() === "admin"
      ? children
      : <Navigate to="/dashboard" replace />;
  };

  if (loading) {
    return <div>Cargando...</div>;
  }

  return (
    <Router>
      {/* Publicas */}
      <Routes>

        {/* 🔓 Ruta pública especial */}
        <Route path="/ejecutivo-obsequios" element={<ObsequiosEjecutivo />} />

        {/* 🆕 🔓 Ruta pública del formulario de afiliación */}
        <Route path="/afiliacion" element={<AfiliacionPublica />} />

        {/* 🆕 🔓 Ruta pública de informes */}
        <Route path="/informe/:codigo" element={<Informes />} />

        <Route path="/resumen-informe/:codigo" element={<Informes modoResumen={true} />} />

        <Route path="/mis-bonos/:token" element={<OrdenKompralo />} />

        <Route path="/solicitudes" element={<Solicitudes />} />

        {/* 🔐 Login */}
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Login
                onLoginSuccess={(userData, remember) => {
                  setIsAuthenticated(true);
                  setUser(userData);

                  if (remember) {
                    localStorage.setItem("user", JSON.stringify(userData));
                    localStorage.setItem("token", userData.token);
                  } else {
                    sessionStorage.setItem("user", JSON.stringify(userData));
                    sessionStorage.setItem("token", userData.token);
                  }
                }}
              />
            )
          }
        />

        {/* 🔀 Redirección raíz */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* 🔒 Rutas privadas dentro del Layout */}
        <Route element={<Layout onLogout={handleLogout} user={user} />}>
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/afiliaciones"
            element={
              <PrivateRoute>
                <Afiliaciones />
              </PrivateRoute>
            }
          />

          <Route
            path="/campaigns"
            element={
              <PrivateRoute>
                <Campaigns />
              </PrivateRoute>
            }
          />

          <Route
            path="/campaigns/:campaignId"
            element={
              <PrivateRoute>
                <CampaignDetail />
              </PrivateRoute>
            }
          />

          <Route
            path="/inventario"
            element={
              <PrivateRoute>
                <Inventario />
              </PrivateRoute>
            }
          />

          <Route
            path="/obsequios"
            element={
              <PrivateRoute>
                <Obsequios />
              </PrivateRoute>
            }
          />

          <Route
            path="/despachos"
            element={
              <PrivateRoute>
                <Despachos />
              </PrivateRoute>
            }
          />

          <Route
            path="/beneficios"
            element={
              <PrivateRoute>
                <Beneficios360 />
              </PrivateRoute>
            }
          />

          <Route
            path="/perfil"
            element={
              <PrivateRoute>
                <PerfilEmpleado />
              </PrivateRoute>
            }
          />

          <Route
            path="/informes"
            element={
              <PrivateRoute>
                <Reportes />
              </PrivateRoute>
            }
          />

          <Route
            path="/boleteria"
            element={
              <PrivateRoute>
                <BancoBonos />
              </PrivateRoute>
            }
          />

          <Route
            path="/creditos"
            element={
              <PrivateRoute>
                <Creditos />
              </PrivateRoute>
            }
          />

          <Route
            path="/payroll"
            element={
              <PrivateRoute>
                <Payroll />
              </PrivateRoute>
            }
          />

          <Route
            path="/payroll/client/:processId"
            element={
              <PrivateRoute>
                <PayrollClientDetail />
              </PrivateRoute>
            }
          />

          {/* 🛑 Solo Admin */}
          <Route
            path="/hub"
            element={
              <AdminRoute>
                <AdminHub />
              </AdminRoute>
            }
          />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
        limit={3}
      />

      {showSessionExpired && (

        <div className="session-overlay">

          <div className="session-modal">

            <h2>
              Sesión Finalizada
            </h2>

            <p>

              Por seguridad tu sesión ha expirado,
              intenta ingresar nuevamente.

            </p>

            <button
              onClick={() => {

                window.location.href =
                  "/login";

              }}
            >

              Ir al login

            </button>

          </div>

        </div>

      )}
    </Router>
  );
}

export default App;
